import React, { useState } from 'react';
import CreateIcon from '@material-ui/icons/Create';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import StyledButton from '../../../../../common/models/Button';
import Dialog from '@material-ui/core/Dialog';
//files
import { useStyles } from '../updateBatchStyles';
import Header from '../../../../../common/sasl/models/Header';
import NewHeader from '../../../../models/NewHeader';
import UploadRecordFiles from './UploadRecordFiles';
import UpdateBMRData from './UpdateBMRData';

const ConsumptionInformation = (props) => {
  const classes = useStyles();

  const [consumptionUpload, setConsumptionUpload] = useState(false);
  const [consumptionView, setConsumptionView] = useState(false);

  const handleUpdate = () => {
    setConsumptionUpload(true);
  };

  const handleCloseUpdate = () => {
    setConsumptionUpload(false);

    if (props.consumptionScreen) {
      props.handleConsumptionDialog();
    }
  };

  const handleViewUpdate = () => {
    setConsumptionView(true);
  };

  const handleCloseView = () => {
    setConsumptionView(false);

    if (props.consumptionScreen) {
      props.handleConsumptionDialog();
    }
  };

  const getLatestFile = (files) => {
    if (!files || files.length === 0) return null; // Handle empty array
    return files.reduce((latest, current) => {
        return new Date(current.lastUpdatedDate) > new Date(latest.lastUpdatedDate) ? current : latest;
    });
  };
  
  
  let bmrFile = props.batchDetails.existingCustomFiles && Array.isArray(props.batchDetails.existingCustomFiles) 
  ? props.batchDetails.existingCustomFiles.filter((val)=> val?.customFileType === 'BMR') : []

  // console.log(bmrFile)
let latestFile = getLatestFile(bmrFile);


// console.log((latestFile) ? latestFile.schrockenCustomFileID : '')

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={12} sm={12} md={6} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Consumption Information Status
          </Typography>
          {(props.batchDetails.bomConsumptionAddedIndicator === true && latestFile !== null )&& (
            <Typography
              variant='body2'
              className={classes.fontPadding}
              onClick={handleViewUpdate}
              style={{
                paddingTop: '0.25rem',
                fontSize: '1rem',
                color: 'blue',
                textDecoration: 'underline',
                cursor:'pointer',
              }}
            >
              Check consumption table
            </Typography>
           )} 
          {(latestFile === null) && (
            <Typography
              variant='body2'
              className={classes.fontPadding}
              style={{
                paddingTop: '0.25rem',
                fontSize: '1rem',
              }}
            >
              -Not Uploaded yet -
            </Typography>
          )}

{(props.batchDetails.bomConsumptionAddedIndicator === false && latestFile !== null) && (
            <Typography
              variant='body2'
              className={classes.fontPadding}
              style={{
                paddingTop: '0.25rem',
                fontSize: '1rem',
                color: 'red',
              }}
            >
              Note - Processing in progress
            </Typography>
          )}
        </Grid>

      
        {(localStorage.collabType === 'CMO' && localStorage.organizationName === "Patheon" && (props.batchDetails.SASLBatchStatusID === 13 || props.batchDetails.SASLBatchStatusID <= 5 )) && (
          <Grid item xs={12} sm={12} md={6} className={classes.grid}>
            <StyledButton
              // startIcon={
              //   localStorage.collabType === 'CMO' && (
              //     <CreateIcon
              //       style={{
              //         fontSize: 15,
              //       }}
              //     />
              //   )
              // }
              className={classes.export}
              onClick={handleUpdate}
            >
              Upload through BMR scan
            </StyledButton>
          </Grid>
        )}
      </Grid>

      {/* <Dialog open={consumptionView} fullScreen>
        <Header title='Consumption Information' handleClose={handleCloseView}>
          <UpdateConsumptionInfo
            {...props}
            handleClose={handleCloseView}
            handleFetchCall={props.handleFetchCall}
          />
        </Header>
      </Dialog> */}

      {/* <ConsumptionViewUploads
        open={consumptionView}
        onClose={handleCloseView}
        batchDetails={props.batchDetails} schrockenCustomFileID={(latestFile) ? latestFile.schrockenCustomFileID : ''}
      /> */}

      {(props.consumptionScreen || consumptionView) &&
         <UpdateBMRData
         {...props}
         open={props.consumptionScreen || consumptionView}
         onClose={handleCloseView}
       handleClose={handleCloseView}
         // handleFetchCall={props.handleFetchCall}
         schrockenCustomFileID={(latestFile) ? latestFile.schrockenCustomFileID : ''}
         batchDetails={props.batchDetails}
         targetQuantity={props.targetQuantity}
       />
      }
     

      <Dialog open={consumptionUpload} fullScreen>
      <NewHeader
        handleClose={handleCloseUpdate}
        title={'Upload BMR'}
        subtitle={'Add/update consumption information by uploading BMR file'}
        padding={true}
        >
          <UploadRecordFiles
            batchDetails={props.batchDetails}
            schrockenDeliveryScheduleID={props.schrockenDeliveryScheduleID}
            handleClose={handleCloseUpdate}
            handleFetchCall={props.handleFetchCall}
          />
      </NewHeader>
      </Dialog>

    </React.Fragment>
  );
};

export default ConsumptionInformation;
